<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="deleteContenidoEntregable"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t('mEditionAssetSendingOfDeliverablesModalDelete.title') }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section">
        <p>
          {{ $t('mEditionAssetSendingOfDeliverablesModalDelete.messageDelete.element') }}
          <b>{{ $modal.element.asunto }}</b>
          {{ $t('mEditionAssetSendingOfDeliverablesModalDelete.messageDelete.options') }}
        </p>
        <small class="text-color-danger">
            {{ $t('mFeedAssetsContentModalDelete.messageDelete.notReversed') }}
        </small>
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction :cancel-text="$t('mEditionAssetSendingOfDeliverablesModalDelete.buttonCancel')"/>
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionAssetSendingOfDeliverablesModalDelete',

  data () {
    return {
      academiaId: '',

      buttonPrimary: {
        action: this.$t('mEditionAssetSendingOfDeliverablesModalDelete.buttonPrimary'),
        behavior: 'delete',
        class: 'a-button-danger-primary',
        sending: false,
        type: 'submit'
      }
    }
  },

  created () {
    this.academiaId = this.$store.getters.getAcademyData.id
  },

  methods: {
    deleteContenidoEntregable () {
      if (!this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.delete('contenido', 'deleteContenidoEntregable', {}, [this.academiaId, this.$modal.element.id])
          .then(response => {
            this.$modal.updateData()
            this.$modal.closeModal()
            this.$alerts.pushAlert('mEditionAssetSendingOfDeliverablesModalDelete', 'deleteContenidoEntregable', 'success')
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionAssetSendingOfDeliverablesModalDelete', 'deleteContenidoEntregable', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    }
  }
}
</script>
